// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ebb13f56","513":"382b0d7c","703":"dc464315","787":"9e28528f"}[chunkId] + ".chunk.js";
};